import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import useProfileStore from 'services/store/ProfileModule';
import useTranslations from 'i18n/useTranslations';

const Welcome = () => {
    const navigate = useNavigate();
    const { lang, supportedLangs, setLang, t } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const profile = useProfileStore(state => state )
    
    const handleLangChange = (language) => {
        setLang(language);
    };
    useEffect(() => {
        console.log("profile",profile)
        if(profile?.isLoaded){
            if(profile?.customerProfile?.id && profile?.customerProfile?.isregisSbSystem  == 1){
                navigate('/profile')
            }else{
                // navigate('/welcome')
            }
        }
    }, [profile]);

    
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageWelcome">
                <main id="top">
                    <div className="wrapContent">
                        <section id="pWelcome">
                            <div className="bLang">
                                <div id="switchLang">
                                    <a className={lang === 'th' ? 'active' : ''} onClick={() => handleLangChange('th')}>ไทย</a>
                                    <a className={lang === 'en' ? 'active' : ''} onClick={() => handleLangChange('en')}>EN</a>
                                </div>
                            </div>
                            <div className="bWelcome">
                                <div className="bText">
                                    <h2>{t.welcome.headTitle}</h2>
                                    <div className="bLogo">
                                        <img src="assets/img/logo/logo-color.svg" alt="" />
                                    </div>
                                    <p>
                                    {t.welcome.body}
                                    </p>
                                </div>
                                <div className="bBtn">
                                    <a  onClick={()=> {
                                            navigate('/verified' + window.location.search)
                                        }}
                                    >
                                        <i className="ico-account"></i>
                                        <span>{t.welcome.existMember}</span>
                                    </a>
                                    <a  onClick={()=> {
                                            navigate('/register' + window.location.search)
                                        }}
                                    >
                                        <i className="ico-register"></i>
                                        <span>{t.welcome.newMember}</span>
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>

            </div>
        </div>
    )
}

export default Welcome